import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class StorageService {

	private onSubject = new Subject<{ key: string, value: any }>();
	public changes = this.onSubject.asObservable().pipe(share());
	private currentStorage: Storage = sessionStorage;
	private currentStorageLocal: Storage = localStorage;

	constructor() { }

	set storage(storage) {
		this.currentStorage = storage;
	}

	public getStorage() {
		let s = [];
		for (let i = 0; i < this.currentStorage.length; i++) {
			s.push({
				key: this.currentStorage.key(i),
				value: JSON.parse(this.currentStorage.getItem(this.currentStorage.key(i)))
			});
		}
		return s;
	}

	public getItem(key: string) {
		let val: any = this.currentStorage.getItem(key);
		return val ? JSON.parse(val) : null;
	}

	public getItemPlain(key: string) {
		return this.currentStorage.getItem(key);
	}

	public getItemLocalPlain(key: string) {
		return this.currentStorageLocal.getItem(key);
	}

	public store(key: string, data: any): void {
		this.currentStorage.setItem(key, JSON.stringify(data));
		// the local application doesn't seem to catch changes to localStorage...
		this.onSubject.next({ key: key, value: data })
	}

	public storePlain(key: string, data: any): void {
		this.currentStorage.setItem(key, data);
		// the local application doesn't seem to catch changes to localStorage...
		this.onSubject.next({ key: key, value: data })
	}

	public storeLocalPlain(key: string, data: any): void {
		this.currentStorageLocal.setItem(key, data);
	}

	public clear(key) {
		this.currentStorage.removeItem(key);
		// the local application doesn't seem to catch changes to localStorage...
		this.onSubject.next({ key: key, value: null });
	}

	public clearLocal(key) {
		this.currentStorageLocal.removeItem(key);
		// the local application doesn't seem to catch changes to localStorage...
		this.onSubject.next({ key: key, value: null });
	}

}
